<template lang="html">
    <div class="hydrologic-variability-chart-legend">
        <h3 class="is-size-7">
            Monthly flow percentile
        </h3>
        <div class="legend-svg-wrap">
            <svg>
                <rect
                    class="bar-outer"
                    :x="margin.left"
                    :y="margin.top"
                    :width="barWidth"
                    :height="height"
                />
                <rect
                    class="bar-inner"
                    :x="margin.left"
                    :y="margin.top + 0.20 * outerHeight"
                    :width="barWidth"
                    :height="innerHeight"
                />
                <!-- add a label for each percentile -->
                <g
                    v-for="percentile in items"
                    :key="percentile.label"
                >
                    <line
                        class="percentile-line"
                        :y1="margin.top + outerHeight * percentile.y / 100"
                        :y2="margin.top + outerHeight * percentile.y / 100"
                        :x1="margin.left"
                        :x2="width - 30"
                    />
                    <text
                        class="percentile-label"
                        :y="margin.top + outerHeight * percentile.y / 100"
                        :x="width - 30 + 5"
                        alignment-baseline="central"
                        v-text="percentile.label"
                    />
                </g>
            </svg>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HydrologicVariabilityChartLegend',

    props: {
        items: {
            type: Array,
            default() {
                return [
                    { label: '90th', y: 0 },
                    { label: '75th', y: 20 },
                    { label: '25th', y: 80 },
                    { label: '10th', y: 100 },
                ];
            },
        },
    },

    data: () => ({
        width: 400,
        height: 400,
        barWidth: 25,
        margin: {
            top: 10, right: 0, bottom: 10, left: 0,
        },
    }),

    computed: {
        outerHeight() {
            // container height
            return this.height;
        },

        innerHeight() {
            // inner bar's top and bottom
            const difference = (this.items[2].y - this.items[1].y) / 100;
            return difference * this.outerHeight;
        },
    },

    mounted() {
        // add resize observer to re-initialize if the size changes
        const resizeObserver = new ResizeObserver((entries) => {
            const { width, height } = entries[0].contentRect;
            if (width && height) {
                this.init();
            }
        });
        resizeObserver.observe(this.$el);
    },

    methods: {
        /**
         * set height and width based on the container's size
         */
        init() {
            const svgWrap = this.$el.querySelector('.legend-svg-wrap');
            this.width = svgWrap.clientWidth - this.margin.left - this.margin.right;
            this.height = svgWrap.clientHeight - this.margin.top - this.margin.bottom - 40; // adjust for the svg title
        },
    },
};
</script>

<style lang="scss">
.hydrologic-variability-chart-legend {
    .legend-svg-wrap {
        > svg {
            height: 100%;
            width: 100%;

            rect,
            line {
                shape-rendering: crispEdges;
            }

            .bar-inner {
                fill: $color-hydrovar-legend-inner;
            }

            .bar-outer {
                fill: $color-hydrovar-legend-outer;
            }

            .percentile-line {
                stroke-width: 1px;
                stroke: $grey-light;
            }

            .percentile-label {
                font-size: 12px;
                fill: currentColor;
            }
        }
    }
}
</style>
